import { httpClient } from "@services/api/httpClient";

export async function getListOfferCategory() {
  const response = await httpClient.get("/offer-category/get-list");
  return response.data;
}